import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ReactSwipeableBottomSheet--open {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=BottomSheet.scss.js.map
